import SignInButton from './registrationButton'

export default SignInButton